import {Component, OnInit} from '@angular/core';
import {
  AccountCreationResponse,
  AccountCreationResponses, AccountCreationSteps
} from "@brightside-web/desktop/feature/financial-accounts-core";
import {ActivatedRoute, Router} from "@angular/router";

import {NewSavingsAccountService} from "../new-savings-account.service";
import {GenericResponseCode} from "@brightside-web/desktop/data-access/core-services";
import {Observable, Subscription} from "rxjs";

@Component({
    selector: 'brightside-web-savings-account-create',
    templateUrl: './savings-account-create.component.html',
    styleUrls: ['./savings-account-create.component.css'],
    standalone: false
})
export class SavingsAccountCreateComponent implements OnInit {

  sub = new Subscription();

  accountCreation: Observable<AccountCreationResponse> = this.savingsSvc.accountCreation;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private savingsSvc: NewSavingsAccountService
  ) {
    this.sub.add(
      this.accountCreation.subscribe(
        resp => {
          switch (resp) {
            case GenericResponseCode.SERVICE_OK:
              this.router.navigate(['../autosave_intro'], {relativeTo: this.route});
              break;
            case AccountCreationResponses.ACCOUNT_ALREADY_EXISTS:
              this.router.navigate(['../../dashboard'], {relativeTo: this.route});
              break;
          }
        }
      )
    )
  }

  ngOnInit(): void {
    this.savingsSvc.createSavingsAccount();
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
